const t = {
  name: "ChevronRightExtraSmall",
  dimensions: { width: 16, height: 16 },
  content: '<path d="M5.43924 10.9999L8.43924 7.99989L5.43924 4.99989L6.4999 3.93923L10.5606 7.99989L6.4999 12.0605L5.43924 10.9999Z" fill="currentColor"/>'
};
export {
  t as ChevronRightExtraSmall
};
